import { useEffect, useState } from 'react'

const useIsClientSide = () => {
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    if (!isClient) {
      setIsClient(true)
    }
  }, [])

  return isClient
}

export default useIsClientSide
